var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c("el-tab-pane", {
            attrs: { label: "产品权重分发列表", name: "patternConfig" },
          }),
          _vm._v(" "),
          _c("el-tab-pane", {
            attrs: { label: "模型列表", name: "patternList" },
          }),
          _vm._v(" "),
          _c("el-tab-pane", {
            attrs: { label: "场景码列表", name: "patternSceneCodeList" },
          }),
          _vm._v(" "),
          _c("el-tab-pane", {
            attrs: { label: "数据链路监控", name: "patternDataMonitor" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }